const FormHelpers = {
  isValidForm: (errors, isTouched) => {
    return (
      Object.keys(errors).length === 0 && Object.keys(isTouched).length > 0
    );
  },
  getValues: (originalValues) => {
    let vals = {
      ...originalValues,
    };
    return vals;
  },
  scrollToTop: () => {
    const pageTop = document.getElementsByClassName("page");
    if(pageTop) {
      window.scrollTo({
        top: pageTop[0].offsetTop,
        behavior: "smooth",
      });
    }
  },
  handleMultilineKeyUp: (e) => {
    FormHelpers.forceMaxLength(e);
    if (e.keyCode == 17 || (e.keyCode == 65 && e.ctrlKey)) {
    }
    else {
        //FormHelpers.fixMultiline(e);
    }
  },
  handleMultilineKeyDown: (e) => {
    if (e.keyCode != 8 && e.keyCode != 46 && e.keyCode != 17 && !e.ctrlKey) {
      //FormHelpers.fixMultiline(e);
    }
  },
  handleMultilineUpdate: (e) => {
    FormHelpers.forceMaxLength(e);
    //FormHelpers.fixMultiline(e);
  },
  cleanupEmptyLines: (e, values, fieldName) => {
    const cleanedText = e.target.value
      .split('\n')
      .filter(line => line.trim() !== '')
      .join('\n');
    e.target.value = cleanedText;
    values[fieldName] = cleanedText;
  },
  forceMaxLength: (e) => {
    const maxLength = Number(e.target.getAttribute('datamax'));
    const inputLength = e.target.value.length-1;

    if (inputLength > maxLength) {
      e.target.value = e.target.value.substring(0, maxLength);
    }
  },
  fixMultiline: (e) => {
    var textArea = e.target;
    var maxRows = Number(e.target.getAttribute('rows'));
    var maxCols = Number(e.target.getAttribute('cols'));
    var myText = e.target.value;
    var lines = [];
    var cursorPosition = textArea.selectionStart;
    var validCodes = [8, 9, 37, 38, 39, 40, 46, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 110, 190];
    var max = e.target.getAttribute('rows');
    var current = document.activeElement;
    var count = 0;
    var currentLine = e.target.value.substr(0, e.target.selectionStart).split("\n").length;

    if (currentLine == maxRows && e.keyCode == 13) {
        e.preventDefault();
    }

    var cursorBefore = cursorPosition;
    if (myText.indexOf('\n') == -1) {
        lines[0] = myText;
    }
    else {
        lines = myText.split('\n');
    }

    var inp = String.fromCharCode(e.keyCode);

    if (inp != "" && inp != "") {
        if (currentLine == maxRows) {
            if (typeof lines[maxRows - 1] != "undefined" && lines[maxRows - 1].length >= maxCols) {
                e.preventDefault();
            }
        }
    }
    var linelength = lines.length;

    for (var i = 0; i < (lines.length); i++) {
        if (lines[i].length > maxCols) {
            var breakPoint = maxCols;
            for (var s = maxCols; s > 0; s--) {
                if (lines[i].charAt(s) == ' ') {
                    breakPoint = s;
                    var charsToSubtract = 0;
                    for (var t = 0; t < (linelength); t++) {
                        if (t + 1 < currentLine) {
                            charsToSubtract += lines[t].length;
                        }
                    }
                    if (i + 1 == currentLine && (cursorPosition - charsToSubtract) > breakPoint) {
                        cursorPosition++;
                    }
                    break;
                }
            }
            var newLine1 = lines[i].substr(0, breakPoint);
            var lettersToWrap = lines[i].substr(breakPoint, lines[i].length - 1);

            lines[i] = newLine1;
            var newStringForTheNextLine = "";
            if (typeof lines[i + 1] !== 'undefined') {

                newStringForTheNextLine = lettersToWrap + lines[i + 1];
                lines[i + 1] = newStringForTheNextLine;
            }
            else {
                newStringForTheNextLine = lettersToWrap;
                lines.push(String(newStringForTheNextLine));
            }

        }

    }

    if (lines.length > 1) {
        var finalString = "";
        for (var i = 0; i < (lines.length); i++) {
            if (i > 0 && i < maxRows) {
                finalString += "\n";
            }
            if (i < maxRows) {
                if (!textArea.classList.contains('customVerseInput')) {
                    finalString += FormHelpers.leftTrim(lines[i]);
                } else {
                    finalString += lines[i];
                }
            }
        }
        
        if (!textArea.classList.contains('customVerseInput')) {
            textArea.value = finalString;
        } else {
            textArea.value = finalString;
        }

        if(cursorBefore == cursorPosition) {
            textArea.selectionEnd = cursorPosition;
        } else {
            textArea.selectionEnd = (cursorPosition-1);
        }
 
    }
  },
  leftTrim: (str) => {
    return str.replace(/^\s+/, "");
  },
};

export default FormHelpers;
